import { z } from "zod";
import { isoDateSchema } from "./common";

export const biologicalSexSchema = z.enum(["MALE", "FEMALE"]);

export const patientProfileSchema = z.object({
  firstName: z.string().trim().min(1, "First name is required").max(100),
  lastName: z.string().trim().min(1, "Last name is required").max(100),
  firstNameAr: z.string().trim().max(100).optional(),
  lastNameAr: z.string().trim().max(100).optional(),
  dateOfBirth: isoDateSchema.refine((v) => new Date(v).getTime() < Date.now(), "Date of birth must be in the past"),
  biologicalSex: biologicalSexSchema,
  nationalId: z.string().trim().max(30).optional(),
  nationality: z.string().trim().max(60).optional(),
  city: z.string().trim().max(100).optional(),
  heightCm: z.coerce.number().min(30).max(280).optional(),
  weightKg: z.coerce.number().min(1).max(400).optional(),
  emergencyContactName: z.string().trim().max(150).optional(),
  emergencyContactPhone: z
    .string()
    .trim()
    .regex(/^\+?[0-9\s-]{7,20}$/, "Enter a valid phone number")
    .optional(),
  isPregnantOrLactating: z.boolean().optional(),
});

export type PatientProfileInput = z.infer<typeof patientProfileSchema>;

export const consentAcceptanceSchema = z.object({
  privacyPolicyVersion: z.string().min(1),
  accepted: z.literal(true, { errorMap: () => ({ message: "Consent must be accepted to continue" }) }),
});
